import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import IResponse = ZoneIQCalibration.IResponse;
import IOverlayTypology = ZoneIQCalibration.IOverlayTypology;

const API = environment.ZONEIQ_CALIBRATION + '/v1/overlay-typology';

@Injectable({
    providedIn: 'root'
})
export class OverlayTypologyService {
    constructor(private readonly http: HttpClient) {}

    saveChanges(overlays: IOverlayTypology[]) {
        if (!_.get(overlays, 'length', 0)) {
            return;
        }
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const params = new HttpParams().set('syncChanges', 'true');

        return this.http.post<IResponse>(API, overlays, { headers, params });
    }
}
